import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Route, Redirect, withRouter } from 'react-router';

const GuestRoute = ({ isLoggedIn, component: Component, ...rest }) => (
  <Route {...rest} render={props => (!isLoggedIn ? <Component {...props} /> : <Redirect to={{ pathname: '/' }} />)} />
);

GuestRoute.propTypes = {
  isLoggedIn: PropTypes.bool.isRequired,
  component: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  isLoggedIn: state.account.login.isLoggedIn,
});

export default withRouter(connect(mapStateToProps)(GuestRoute));
